import store from "@/store";
import { v4 as uuid } from "uuid";
import { isNil } from "lodash";

let dialogs = [];

export const alert = ({ title, text, confirmBtnText = "확인", zIndex } = {}) => {
  return new Promise((resolve, reject) => {
    const data = {
      id: uuid(),
      title,
      text,
      buttons: [
        {
          title: confirmBtnText,
          type: "primary",
          value: true,
        },
      ],
      zIndex,
    };
    store.dispatch("addDialog", data);
    dialogs = [...dialogs, { ...data, resolve, reject }];
  });
};

export const confirm = ({
  title,
  text,
  confirmBtnText = "확인",
  cancelBtnText = "취소",
  zIndex,
} = {}) => {
  return new Promise((resolve, reject) => {
    const data = {
      id: uuid(),
      title,
      text,
      buttons: [
        {
          title: cancelBtnText,
          type: "default",
          value: false,
        },
        {
          title: confirmBtnText,
          type: "primary",
          value: true,
        },
      ],
      zIndex,
    };
    store.dispatch("addDialog", data);
    dialogs = [...dialogs, { ...data, resolve, reject }];
  });
};

export const show = ({
  title,
  text,
  buttons = [
    {
      title: "확인",
      type: "primary",
      value: true,
    },
  ],
  zIndex,
} = {}) => {
  return new Promise((resolve, reject) => {
    const data = {
      id: uuid(),
      title,
      text,
      buttons,
      zIndex,
    };
    store.dispatch("addDialog", data);
    dialogs = [...dialogs, { ...data, resolve, reject }];
  });
};

export const resolve = (id, data) => {
  const dialog = dialogs.find((item) => item.id === id);
  dialog.resolve(data);
};

export const reject = (id) => {
  const dialog = dialogs.find((item) => item.id === id);
  dialog.reject();
};

const _close = (id) => {
  dialogs = dialogs.filter((item) => item.id !== id);
  store.dispatch("removeDialog", id);
};

export const close = (id, data) => {
  const dialog = dialogs.find((item) => item.id === id);
  if (dialog.buttons.length === 1) {
    resolve(id, true);
  } else if (!isNil(data)) {
    resolve(id, data);
  } else {
    reject(id);
  }
  _close(id);
};

export const closeAll = () => {
  dialogs.forEach((item) => close(item.id));
};

export default {
  alert,
  confirm,
  close,
  closeAll,
  resolve,
  reject,
};
